<template>
    <div v-if="variant === 'grid'" class="grid grid-cols-2 gap-3">
        <component
            :is="item.href ? 'a' : 'div'"
            v-for="item in sliderItems"
            :key="item.key"
            v-bind="linkAttrs(item)"
            :aria-label="item.title"
            class="flex w-full min-h-12 items-center justify-center gap-3 rounded-xl bg-stack-emphasis p-3 text-stack-ink no-underline shadow-sm sm:min-h-20 sm:p-4"
            @click="onClick"
        >
            <div
                v-if="item.imageUrl"
                class="h-12 w-12 flex-none overflow-hidden rounded-full"
            >
                <img
                    :src="item.imageUrl"
                    :alt="item.imageAlt"
                    class="h-full w-full object-cover"
                />
            </div>
            <span
                class="min-w-0 max-w-full truncate text-center text-sm font-semibold"
            >
                {{ item.title }}
            </span>
        </component>
    </div>

    <div v-else class="flex flex-col gap-3">
        <component
            :is="item.href ? 'a' : 'div'"
            v-for="item in sliderItems"
            :key="item.key"
            v-bind="linkAttrs(item)"
            :aria-label="item.title"
            class="flex w-full min-h-12 items-center justify-center gap-3 rounded-xl bg-stack-emphasis p-3 text-stack-ink no-underline shadow-sm sm:min-h-20 sm:p-4"
            @click="onClick"
        >
            <div
                v-if="item.imageUrl"
                class="h-12 w-12 flex-none overflow-hidden rounded-full"
            >
                <img
                    :src="item.imageUrl"
                    :alt="item.imageAlt"
                    class="h-full w-full object-cover"
                />
            </div>
            <span
                class="min-w-0 max-w-full truncate text-center text-sm font-semibold"
            >
                {{ item.title }}
            </span>
        </component>
    </div>
</template>

<script>
export default {
    name: "LinksSegment",
    props: {
        links: { type: Array, required: true },
        variant: { type: String, default: "block" },
        openInNewTab: { type: Boolean, default: false },
        previewOnly: { type: Boolean, default: false }
    },
    computed: {
        sliderItems() {
            return this.links.map((link) => ({
                key: link.id,
                href: link.url,
                target: this.openInNewTab ? "_blank" : undefined,
                rel: this.openInNewTab ? "noopener noreferrer" : undefined,
                imageUrl: link.imageUrl,
                imageAlt: link.title,
                title: link.title
            }));
        }
    },
    methods: {
        linkAttrs(item) {
            return item.href
                ? { href: item.href, target: item.target, rel: item.rel }
                : {};
        },
        onClick(event) {
            if (this.previewOnly) event.preventDefault();
        }
    }
};
</script>
